import { IAccount, IStep } from 'src/types'
import { MutableRefObject, useMemo } from 'react'
import { JourneyMap, DescriptionPreview } from 'src/components'
import { PageWrapper } from '../fairtrade.styled'
import { QuillHtmlParser } from 'src/components'
import { FAIRTRADE_FONT_STACK } from '../constants'
import { FairtradeFonts } from '../fairtrade-fonts'
import { MapProvider } from 'src/contexts/journey-map.context'
import { FairtradeJourneySteps } from './fairtrade-journey-steps'
import { JOURNEY_PAGE_TEMPLATE_ID } from 'src/templates/constants'
import { useTranslation } from 'react-i18next'

interface IProps {
  steps: IStep[]
  account: IAccount
  topRef: MutableRefObject<HTMLSpanElement>
  scrollToRef: MutableRefObject<HTMLSpanElement>
  isImpacts: boolean
  accauntSimpleId: string
  productName?: string
  journeyDescription?: string
}

export const FairtradeJourneyTemplate = ({
  steps,
  account,
  topRef,
  scrollToRef,
  isImpacts,
  accauntSimpleId,
  journeyDescription,
}: IProps) => {
  const [t] = useTranslation()

  const navBackground = useMemo(
    () => account?.alternative_color || '#DBFF4C',
    [account?.alternative_color],
  )

  const productLabel = t('journey-navigation-product-button')
  const impactsLabel = t('journey-navigation-impacts-button')
  const accountLabel = t('journey-navigation-account-button')

  const aboutAccountLabel = account?.account_holder
    ? `${accountLabel} ${account.account_holder}`
    : 'About this account'
  const nextLabel = isImpacts ? impactsLabel : aboutAccountLabel

  return (
    <PageWrapper id="index__templates-fairtrade-journey__pagewrapper__l52">
      <FairtradeFonts />
      <span id="index__templates-fairtrade-journey__span__l54" ref={topRef} />
      {/* <PageTitle
        id="index__templates-fairtrade-journey__pagetitle__l55"
        sx={{
          marginBottom: '10px',
          marginX: {
            xs: '24px',
            md: '8px',
          },
        }}
      >
        {t('journey-header-title')}
      </PageTitle> */}

      <MapProvider>
        <JourneyMap
          steps={steps}
          satelliteView={account.map_satellite_view}
          scrollToRef={scrollToRef}
          markerColor={account?.primary_color}
          isTopDivider={false}
          isImpacts={isImpacts}
          accauntId={accauntSimpleId}
          // navButtonsTopOffset={43}
          mapHeight="55vh"
          mapMaxHeight="450px"
          navVariant={JOURNEY_PAGE_TEMPLATE_ID.FAIRTRADE}
          prevLabel={productLabel}
          nextLabel={nextLabel}
          navBackgroundColor={navBackground}
          navTextColor="#111111"
        />

        <span id="index__templates-fairtrade-journey__span__l107" ref={scrollToRef} />
        {journeyDescription && journeyDescription !== '<p><br></p>' && (
          <DescriptionPreview
            contentKey={`journey-description`}
            toggleColor={account.primary_color || null}
          >
            <QuillHtmlParser
              html={journeyDescription}
              fontSize="20px"
              sx={{
                mt: '32px',
                mx: {
                  xs: '6px',
                  md: '0px',
                },
                paddingX: '20px',
                fontFamily: FAIRTRADE_FONT_STACK,
              }}
            />
          </DescriptionPreview>
        )}
        <FairtradeJourneySteps steps={steps} account={account} topRef={topRef} />
      </MapProvider>
    </PageWrapper>
  )
}
